// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://dev-api.payspective.com/api/v1',
  loginApiUrl: 'https://dev-login-api.payspective.com/api/v1',
  b2bApiUrl: 'https://dev-b2b-dashboard-api.payspective.com/api/v1',
  // apiUrl: 'http://localhost:3524/api/v1',
  // loginApiUrl: 'http://localhost:3000/api/v1',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
